export const companyName = 'PT Stockbit Sekuritas Digital';
export const address =
  'RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta 12930';
export const supportEmail = 'support@stockbit.com';
export const phone = '+62 21 50959-330';
export const marketingEmail = 'marketing@stockbit.com';
export const companyEmail = 'company@stockbit.com';
